export default function(state = {}, action) {
    switch (action.type) {
        case 'SET_SITE':
            return {...state, id: action.payload};
        default:
            return state;
    }
}